import React from 'react';
import { Nav, Footer } from '../../design-system';

export default function MarketingLayout({ children, navDark = true }) {
  return (
    <div className="min-h-screen bg-white">
      <Nav dark={navDark} />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
